import React from "react"

const Spinner = prop => {
  return prop.loading ? (
    <div className="overlay d-flex justify-content-center align-items-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default Spinner
